export default __webpack_public_path__ + "static/media/warning.88e2b6ce.png";